import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Authentication from '../../../libs/api/services/Authentication'

export default function DashbaordRedirectComponent() {
    const navigate = useNavigate()
    useEffect(() => {
        const redirect = async () => {
            if (!await Authentication.token()) return window.location = '/logout'
            const roles = await Authentication.facilities()
            await Authentication.setFacility(Authentication.isClaimValid("System Admin") ? -1 : roles[0].facility.id, roles[0].roles.id)

            if (Authentication.isClaimValid("System Admin")) {
                return window.location = '/sys-admin'
            }
            const searchParams = new URLSearchParams(document.location.search);
            searchParams.get('goto')
            // window.location = '/' + Authentication.getFacilityRole()
            // setTimeout(() => { navigate('/' + Authentication.getFacilityRole()) }, 1500)
            setTimeout(() => { navigate(searchParams.get('goto') ? searchParams.get('goto') : '/Dashboard') }, 1500)
        }

        redirect()

    }, [])
    return (
        <div
            style={{ background: 'rgba(0,0,0,0.3)', position: 'absolute', top: '0px', buttom: '0px', left: '0px', right: '0px', height: '100vh' }}
            className='d-flex justify-content-center align-items-center'
        >

            <div className='bg-light rounded p-3 shadow text-dark'>
                <FontAwesomeIcon className='me-2' icon={faSpinner} spin />
                Loading</div>
        </div>
    )
}
